<template>
  <div
    ref="ball"
    class="draggable-ball"
   
    :style="{ right: position.right + 'px', top: position.top + 'px' }"
  >
  <Icon color="#fff" size="24" icon="ep:caret-bottom"/>
  </div>
</template>
<!-- @mousedown="onMouseDown" -->
<script setup lang="ts">
import { ref } from 'vue';
const position = ref({ right: 20, top: -10 });
const isDragging = ref(false);
let startX = 0;
let startY = 0;
let initialRight = 0;
let initialTop = 0;

const onMouseDown = (event: MouseEvent) => {
  isDragging.value = true;
  startX = event.clientX;
  startY = event.clientY;
  initialRight = position.value.right;
  initialTop = position.value.top;

  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
};

const onMouseMove = (event: MouseEvent) => {
  if (!isDragging.value) return;

  const deltaX = startX - event.clientX;
  const deltaY = event.clientY - startY;

  position.value.right = initialRight + deltaX;
  
  // 计算新的顶部位置并限制在 0 到 50px 之间
  let newTop = initialTop + deltaY;
  if (newTop < 0) newTop = 0;
  if (newTop > 30) newTop = 30;

  position.value.top = newTop;
};

const onMouseUp = () => {
  isDragging.value = false;

  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);
};
</script>

<style scoped>
.draggable-ball {
  width: 40px;
  height: 40px;
  background-color:rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
  user-select: none;
  z-index: 1000;display: flex;align-items: center;justify-content: center;
}
</style>
